import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function Training() {
    return (
        <>
            <Box
                id="training"
                sx={{
                    width: '100%',
                    backgroundColor: '#141414',
                    pt: 6,
                    pb: 0
                }}
            >
                <Container maxWidth="lg">
                    <Grid sx={{ pb: 6 }} container alignItems="center" spacing={4}>
                        {/* Image Section */}
                        <Grid item xs={12} sm={6}>
                            <Box
                                component="img"
                                src="/img/training.jpeg" // Replace with actual image path
                                alt="Cybersecurity Training and Simulation"
                                sx={{
                                    width: '100%',
                                    borderRadius: 2,
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                                }}
                            />
                        </Grid>

                        {/* Content Section */}
                        <Grid item xs={12} sm={6}>
                            <Box sx={{ color: 'white', textAlign: 'left' }}>
                                {/* Subtitle */}
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        color: '#1e88e5', // Blue color for subtitle
                                        fontWeight: 'bold',
                                        mb: 1,
                                    }}
                                >
                                    Train, Test, and Drill
                                </Typography>

                                {/* Heading */}
                                <Typography
                                    variant="h2"
                                    sx={{
                                        fontSize: '32px',
                                        fontWeight: '600',
                                        mb: 2,
                                    }}
                                >
                                    Build Skills for Real-World Challenges
                                </Typography>

                                {/* Paragraph */}
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: 'rgba(255, 255, 255, 0.85)',
                                        mb: 4,
                                    }}
                                >
                                    Step into our interactive training sessions, where security and cloud professionals collaborate to gain hands-on experience
                                    and actionable insights into the ever-evolving landscape of cybersecurity and cloud computing. For organizations,
                                    our realistic simulation drills offer a critical platform to assess and strengthen cyber resilience, enabling teams
                                    to anticipate and effectively counter emerging threats.
                                </Typography>
                                {/* Button */}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    href="/training"
                                >
                                    Start Your Journey
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box
                        sx={{
                            width: '100%',
                            borderBottom: '1px solid white',
                        }}
                    />
                </Container>
            </Box>
        </>
    );
}
